import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=f329347e&scoped=true"
import script from "./menuTree.vue?vue&type=script&lang=js"
export * from "./menuTree.vue?vue&type=script&lang=js"
import style0 from "./menuTree.vue?vue&type=style&index=0&id=f329347e&prod&lang=scss"
import style1 from "./menuTree.vue?vue&type=style&index=1&id=f329347e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f329347e",
  null
  
)

export default component.exports